<script lang="ts">
  import {goto} from '$app/navigation';
  import netlifyIdentity from 'netlify-identity-widget';

  import {getParameterizedRoute} from '$lib/utils/routes';

  import {Button} from '$lib/components/button';

  import {Route} from '$lib/enums/routes';

  import {Icon, IconId} from '$lib/components/icon';
  import {Loader} from '$lib/components/loader';

  import {authService} from '$lib/stores/auth';

  const homeRoute = getParameterizedRoute(Route.Home);

  function openModal(action: 'login' | 'signup') {
    return () => {
      netlifyIdentity.open(action);
    };
  }

  $: if ($authService.matches('authd')) {
    goto(homeRoute);
  }
</script>

<div class="flex-context">
  <div class="flex-context flex-context__child flex-context__child--fill">
    <div class="u-text--center">
      {#if $authService.matches('unknown') || $authService.matches('initial')}
        <Loader>Loading...</Loader>
      {:else if $authService.matches('loggingOut')}
        <Loader>Logging out...</Loader>
      {:else if $authService.matches('notAuthd')}
        <Button on:click={openModal('login')}>
          <span>
            <Icon id={IconId.Target} />
          </span>

          Log in
        </Button>
      {/if}
    </div>
  </div>
</div>
